module.exports = __webpack_public_path__ + "static/media/cloud-4.251c7eed.svg";